export default class PublicacaoCreatePublicacaoController {
  constructor($q, $state, $scope, AuthenticationService, UIService, PublicacaoService, Publicacao, PublicacaoAutor, PublicacaoTipo, PublicacaoAreaInterdisciplinar, PublicacaoGrupoInvestigacao, Ranking, Investigador, AreaInterdisciplinar, GrupoInvestigacao, Impacto, ImpactoOds, Ods, Pais, InvestigadorTooltip, Revista) {
    this.$q = $q;
    this.state = $state;
    this.$scope = $scope;
    this.UI = UIService;
    this.user = AuthenticationService.getUser();
    this.PublicacaoService = PublicacaoService;
    this.loaded = false;

    this.Publicacao = Publicacao;
    this.PublicacaoAutor = PublicacaoAutor;
    this.PublicacaoTipo = PublicacaoTipo;
    this.PublicacaoAreaInterdisciplinar = PublicacaoAreaInterdisciplinar;
    this.PublicacaoGrupoInvestigacao = PublicacaoGrupoInvestigacao;
    this.Ranking = Ranking;
    this.Investigador = Investigador;
    this.AreaInterdisciplinar = AreaInterdisciplinar;
    this.GrupoInvestigacao = GrupoInvestigacao;
    this.Impacto = Impacto;
    this.ImpactoOds = ImpactoOds;
    this.Ods = Ods;
    this.Pais = Pais;
    this.InvestigadorTooltip = InvestigadorTooltip;
    this.Revista = Revista;
    this.simnao = [{ name: "Sim", value: 1 }, { name: "Não", value: 0 }];
    this.tiposPublicacao = null;
    this.rankings = null;
    this.currentYear = moment().format('YYYY');
    this.investigadores = null;
    this.revistas = null;
    this.publicacaoCreated = false;

    this.autoresOptions = {
      containment: 'parent',
      tolerance: 'pointer',
      handle: '.pmd-move-handle',
      'ui-floating': true,
      stop: (e, ui) => {
        for (let i in this.data.autores) {
          this.data.autores[i].ordem = Number(i) + 1;
        }
      }
    };

    this.emptyData = {
      form: 1,
      details: {},
      impacto: {ods: []},
      blockedFields: {},

      autores: [],
      areas: [],
      grupos: [],
      auxInvestigador: {selected: undefined, infiniteScroll: {numToAdd: 20, currentItems: 20}},

      auxTipo: {selected: undefined, infiniteScroll: {numToAdd: 20, currentItems: 20}},
      auxRanking: {selected: undefined, infiniteScroll: {numToAdd: 20, currentItems: 20}},
      auxRevista: {selected: undefined, infiniteScroll: {numToAdd: 20, currentItems: 20}},

      auxScopus: {selected: undefined, infiniteScroll: {numToAdd: 20, currentItems: 20}},
      auxCited: {selected: undefined, infiniteScroll: {numToAdd: 20, currentItems: 20}},
      auxDifferent: {selected: undefined, infiniteScroll: {numToAdd: 20, currentItems: 20}},
      auxOpenAccess: {selected: undefined, infiniteScroll: {numToAdd: 20, currentItems: 20}},
      auxSpecialIssue: {selected: undefined, infiniteScroll: {numToAdd: 20, currentItems: 20}},
      auxInternationalConference: {selected: undefined, infiniteScroll: {numToAdd: 20, currentItems: 20}},
      auxCitizen: {selected: undefined, infiniteScroll: {numToAdd: 20, currentItems: 20}},
      auxPerformed: {selected: undefined, infiniteScroll: {numToAdd: 20, currentItems: 20}},
      auxSocialJustice: {selected: undefined, infiniteScroll: {numToAdd: 20, currentItems: 20}},
      auxInternational: {selected: undefined, infiniteScroll: {numToAdd: 20, currentItems: 20}},
      auxDevelopingCountries: {selected: undefined, infiniteScroll: {numToAdd: 20, currentItems: 20}},
      auxIndustry: {selected: undefined, infiniteScroll: {numToAdd: 20, currentItems: 20}},

      auxImpactoAmbiental: {selected: undefined, infiniteScroll: {numToAdd: 20, currentItems: 20}},
      auxImpactoEconomico: {selected: undefined, infiniteScroll: {numToAdd: 20, currentItems: 20}},
      auxImpactoSocial: {selected: undefined, infiniteScroll: {numToAdd: 20, currentItems: 20}},
      auxImpactoPolicyInfluence: {selected: undefined, infiniteScroll: {numToAdd: 20, currentItems: 20}}
    };

    // Load data to fill ui-selects
    this.loadAuxData();

    $scope.$watch(() => {
      return this.data;
    }, (val) => {
      if (angular.isDefined(val)) {
        if (this.publicacaoCreated === false) // Only do this if it hasn't been submitted already
          localStorage.setItem('ISR_SGI_PublicacaoNewForm', JSON.stringify(val));
      }
    }, true);
  }

  loadAuxData = () => {
    this.Revista.find({
      filter: {
        fields: {id: true, nome: true, issn: true, issnOnline: true}
      }
    }).$promise.then(revistas => {
      revistas.sort((a, b) => a.nome.localeCompare(b.nome));
      this.revistas = revistas;
      this.InvestigadorTooltip.find({}).$promise.then((tooltips) => {
        this.rankingTooltip = tooltips.find(x => x.id === 11); // Ranking specific tooltip
        this.Ranking.find({}).$promise.then((rankings) => {
          this.rankings = rankings;
          this.PublicacaoTipo.find({}).$promise.then((tiposPublicacao) => {
            this.tiposPublicacao = tiposPublicacao;
            this.Investigador.find({}).$promise.then((investigadores) => {
              investigadores.sort((a, b) => a.nome.localeCompare(b.nome));
              this.investigadores = investigadores;
              this.loadDataFromStorage();
              this.loaded = true;
            }).catch(err => {
              console.log(err);
              this.UI.addToast("Erro ao carregar investigadores. Verifique a sua ligação");
              this.state.go('app.publicacao.list');
            });
          }).catch(err => {
            console.log(err);
            this.UI.addToast("Erro ao carregar tipos de publicação. Verifique a sua ligação");
            this.state.go('app.publicacao.list');
          });
        }).catch(err => {
          console.log(err);
          this.UI.addToast("Erro ao carregar rankings para publicação. Verifique a sua ligação");
          this.state.go('app.publicacao.list');
        });
      }).catch(err => {
        console.log(err);
        this.UI.addToast("Erro ao carregar tooltips. Verifique a sua ligação");
        this.state.go('app.publicacao.list');
      });
    }).catch(err => {
      console.log(err);
      this.UI.addToast("Erro ao carregar revistas. Verifique a sua ligação");
      this.state.go('app.publicacao.list');
    });

  };

  // Infinite Scroll magic
  addMoreItems = (infiniteScroll) => {
    infiniteScroll.currentItems += infiniteScroll.numToAdd;
  };

  loadDataFromStorage = () => {
    if (localStorage.getItem('ISR_SGI_PublicacaoNewForm')) {
      let storageData = JSON.parse(localStorage.getItem('ISR_SGI_PublicacaoNewForm'));
      // Only use what is required
      this.data = {};
      if (storageData.form) this.data.form = storageData.form; else this.data.form = angular.copy(this.emptyData.form);
      if (storageData.details) this.data.details = storageData.details; else this.data.details = angular.copy(this.emptyData.details);
      if (storageData.blockedFields) this.data.blockedFields = storageData.blockedFields; else this.data.blockedFields = angular.copy(this.emptyData.blockedFields);
      if (storageData.impacto) this.data.impacto = storageData.impacto; else this.data.impacto = angular.copy(this.emptyData.impacto);

      if (storageData.autores) this.data.autores = storageData.autores; else this.data.autores = angular.copy(this.emptyData.autores);
      if (storageData.areas) this.data.areas = storageData.areas; else this.data.areas = angular.copy(this.emptyData.areas);
      if (storageData.grupos) this.data.grupos = storageData.grupos; else this.data.grupos = angular.copy(this.emptyData.grupos);

      if (storageData.auxInvestigador) this.data.auxInvestigador = storageData.auxInvestigador; else this.data.auxInvestigador = angular.copy(this.emptyData.auxInvestigador);

      if (storageData.auxTipo) this.data.auxTipo = storageData.auxTipo; else this.data.auxTipo = angular.copy(this.emptyData.auxTipo);
      if (storageData.auxRanking) this.data.auxRanking = storageData.auxRanking; else this.data.auxRanking = angular.copy(this.emptyData.auxRanking);
      if (storageData.auxRevista) this.data.auxRevista = storageData.auxRevista; else this.data.auxRevista = angular.copy(this.emptyData.auxRevista);

      if (storageData.auxScopus) this.data.auxScopus = storageData.auxScopus; else this.data.auxScopus = angular.copy(this.emptyData.auxScopus);
      if (storageData.auxCited) this.data.auxCited = storageData.auxCited; else this.data.auxCited = angular.copy(this.emptyData.auxCited);
      if (storageData.auxDifferent) this.data.auxDifferent = storageData.auxDifferent; else this.data.auxDifferent = angular.copy(this.emptyData.auxDifferent);
      if (storageData.auxOpenAccess) this.data.auxOpenAccess = storageData.auxOpenAccess; else this.data.auxOpenAccess = angular.copy(this.emptyData.auxOpenAccess);
      if (storageData.auxSpecialIssue) this.data.auxSpecialIssue = storageData.auxSpecialIssue; else this.data.auxSpecialIssue = angular.copy(this.emptyData.auxSpecialIssue);
      if (storageData.auxInternationalConference) this.data.auxInternationalConference = storageData.auxInternationalConference; else this.data.auxInternationalConference = angular.copy(this.emptyData.auxInternationalConference);
      if (storageData.auxCitizen) this.data.auxCitizen = storageData.auxCitizen; else this.data.auxCitizen = angular.copy(this.emptyData.auxCitizen);
      if (storageData.auxPerformed) this.data.auxPerformed = storageData.auxPerformed; else this.data.auxPerformed = angular.copy(this.emptyData.auxPerformed);
      if (storageData.auxSocialJustice) this.data.auxSocialJustice = storageData.auxSocialJustice; else this.data.auxSocialJustice = angular.copy(this.emptyData.auxSocialJustice);
      if (storageData.auxInternational) this.data.auxInternational = storageData.auxInternational; else this.data.auxInternational = angular.copy(this.emptyData.auxInternational);
      if (storageData.auxDevelopingCountries) this.data.auxDevelopingCountries = storageData.auxDevelopingCountries; else this.data.auxDevelopingCountries = angular.copy(this.emptyData.auxDevelopingCountries);
      if (storageData.auxIndustry) this.data.auxIndustry = storageData.auxIndustry; else this.data.auxIndustry = angular.copy(this.emptyData.auxIndustry);

      if (storageData.auxImpactoAmbiental) this.data.auxImpactoAmbiental = storageData.auxImpactoAmbiental; else this.data.auxImpactoAmbiental = angular.copy(this.emptyData.auxImpactoAmbiental);
      if (storageData.auxImpactoEconomico) this.data.auxImpactoEconomico = storageData.auxImpactoEconomico; else this.data.auxImpactoEconomico = angular.copy(this.emptyData.auxImpactoEconomico);
      if (storageData.auxImpactoSocial) this.data.auxImpactoSocial = storageData.auxImpactoSocial; else this.data.auxImpactoSocial = angular.copy(this.emptyData.auxImpactoSocial);
      if (storageData.auxImpactoPolicyInfluence) this.data.auxImpactoPolicyInfluence = storageData.auxImpactoPolicyInfluence; else this.data.auxImpactoPolicyInfluence = angular.copy(this.emptyData.auxImpactoPolicyInfluence);
    } else {
      this.data = angular.copy(this.emptyData);
    }
    // Check if we need to know which investigador the publication is from. If not, show modal, if so, do transition
    if (this.data.auxInvestigador.selected && this.data.auxInvestigador.selected.id > 0) {
      this.state.transitionTo('app.publicacao.new.' + this.data.form);
    } else {
      this.requestInvestigadorPublicacao().then(() => {
        this.state.transitionTo('app.publicacao.new.' + this.data.form);
      }).catch(err => {
        console.log(err);
        this.UI.addToast("É necessário escolher autor/publicação a inserir");
        this.state.go('app.publicacao.list');
      });
    }
  };

  requestInvestigadorPublicacao = () => {
    let defer = this.$q.defer();
    let options = {
      size: 'lg',
      template: require('./choose.investigador.dialog.html'),
      controller: ['$scope', '$dialog', ($scope, $dialog) => {
        $scope.label = "Autor da Publicação";
        $scope.investigadores = this.investigadores;

        $scope.loading = false;
        $scope.error = false;
        $scope.errorMessage = "";
        $scope.publicacoes = [];

        $scope.auxInvestigador = {
          selected: undefined,
          infiniteScroll: {numToAdd: 20, currentItems: 20}
        };
        $scope.auxPublicacao = {
          selected: undefined,
          infiniteScroll: {numToAdd: 20, currentItems: 20}
        };

        // Called just before switch is toggled, so logic is reversed
        $scope.onInvestigadorSelected = () => {
          $scope.loading = true;
          $scope.publicacoes = [];
          $scope.auxPublicacao.selected = undefined;

          if ($scope.auxInvestigador.selected.orcidId) {
            this.PublicacaoService.getPublicacoesByOrcidId($scope.auxInvestigador.selected).then((data) => {
              $scope.publicacoes = data.data;
              $scope.loading = false;
              $scope.error = false;
            }).catch(err => {
              console.log(err);
              $scope.loading = false;
              $scope.error = true;
              if (err.status === 404) {
                $scope.errorMessage = "ORCID ID inválido. Verifique os dados";
              } else {
                $scope.errorMessage = "Erro na procura de publicações no ORCID. Verifique a ligação";
              }

            });
          } else {
            $scope.loading = false;
            $scope.error = true;
            $scope.errorMessage = "O Investigador não tem ORCID ID, não é possível fazer a importação de publicações do mesmo";
          }
        };

        $scope.getTipo = (tag) => {
          let p = this.tiposPublicacao.find(x => x.tag === tag);
          if (p) return p.designacao;
          else return '';
        }

        $scope.getDataPublicacao = (item) => {
          if (item.dia && item.mes && item.ano)
            return `${item.dia}/${item.mes}/${item.ano}`;
          if (item.mes && item.ano)
            return `${item.mes}/${item.ano}`;
          if (item.ano)
            return `${item.ano}`;
          else
            return '';
        };

        // Infinite Scroll magic
        $scope.addMoreItems = (infiniteScroll) => {
          infiniteScroll.currentItems += infiniteScroll.numToAdd;
        };

        $scope.ok = () => {
          $dialog.close($scope);
        };

        $scope.cancel = () => {
          $dialog.dismiss('cancel');
        };
      }]
    };
    let dialogEdit = this.UI.showDialog(options);
    dialogEdit.then(ok => {
      this.loaded = false;
      if (ok.auxInvestigador && ok.auxPublicacao && ok.auxInvestigador.selected && ok.auxPublicacao.selected) {
        this.PublicacaoService.getPublicacaoData(ok.auxInvestigador.selected.orcidId, ok.auxPublicacao.selected.putCode).then((data) => {
          // Update data if available
          this.data.details.putCode = data.putCode;
          this.data.details.orcidBaseId = data.orcidBaseId;

          if (data.orcidCreatedDate) this.data.details.orcidCreatedDate = data.orcidCreatedDate;
          if (data.orcidLastModifiedDate) this.data.details.orcidLastModifiedDate = data.orcidLastModifiedDate;

          if (data.dia) { this.data.details.dia = data.dia; this.data.blockedFields.dia = true; }
          if (data.mes) { this.data.details.mes = data.mes; this.data.blockedFields.mes = true; }
          if (data.ano) { this.data.details.ano = data.ano; this.data.blockedFields.ano = true; }

          // Show always show slug
          this.data.details.slug = this.PublicacaoService.stringToSlug(data.titulo);

          if (data.titulo) { this.data.details.titulo = data.titulo; this.data.blockedFields.titulo = true; }
          if (data.tituloSupra) { this.data.details.tituloSupra = data.tituloSupra; this.data.blockedFields.tituloSupra = true; }
          if (data.repositorio) { this.data.details.repositorio = data.repositorio; this.data.blockedFields. repositorio = true; }

          if (data.doiShort) { this.data.details.doiShort = data.doiShort; this.data.blockedFields.doiShort = true; }
          if (data.doiWww) { this.data.details.doiWww = data.doiWww; this.data.blockedFields.doiWww = true; }

          if (data.isbn) { this.data.details.isbn = data.isbn; this.data.blockedFields.isbn = true; }
          if (data.issn) {
            this.data.details.issn = data.issn;
            this.data.blockedFields.issn = true;
            this.data.auxRevista.selected = this.revistas.find(x => x.issn === data.issn || x.issnOnline === data.issn);
            if (!this.data.auxRevista.selected) {
              // Special case just to give a message of revista not found
              this.data.blockedFields.auxRevistaNotFound = true;
            } else {
              this.data.blockedFields.auxRevista = true;
            }
          }

          if (data.tipo) {
            this.data.auxTipo.selected = this.tiposPublicacao.find(x => x.tag === data.tipo);
            this.data.blockedFields.tipo = !!this.data.auxTipo.selected;
          }
          if (data.autores) this.data.autores = data.autores; // Do not block autores

          this.data.auxInvestigador = ok.auxInvestigador;
          this.data.auxPublicacao = ok.auxPublicacao;
          this.loaded = true;
          defer.resolve();
        }).catch(err => {
          console.log(err);
          this.UI.addToast("Não foi possível obter dados de publicação. Tente novamente");
          this.loaded = true;
          defer.reject();
        });
      } else {
        this.loaded = true;
        defer.reject();
      }
    }).catch(() => {
      defer.reject();
    });
    return defer.promise;
  };

  setForm = num => {
    this.data.form = num;
    this.state.transitionTo('app.publicacao.new.' + this.data.form);
  };

  cleanForm = () => {
    // Clean filled data
    this.data = angular.copy(this.emptyData);
    // Ask for investigador, publicacao
    this.requestInvestigadorPublicacao().then(() => {
      this.state.transitionTo('app.publicacao.new.' + this.data.form);
    }).catch(err => {
      console.log(err);
      this.UI.addToast("É necessário escolher autor/publicação a inserir");
      this.state.go('app.publicacao.list');
    });
  };

  submit = () => {
    this.isValid().then(() => {
      this.loaded = false;
      // Create Publicacao and related data
      this.data.details.id = 0;
      this.data.details.tipoId = this.data.auxTipo.selected.id;
      this.data.details.revistaId = this.data.auxRevista.selected ? this.data.auxRevista.selected.id : null;
      // if we have revista selected, but no ISSN, use its ISSN for the publicacao if it's not filled (for consistency).
      if (this.data.auxRevista.selected && !this.data.details.issn) {
        this.data.details.issn = this.data.auxRevista.selected.issn ? this.data.auxRevista.selected.issn : this.data.auxRevista.selected.issnOnline;
      }

      // Ranking is saved by value only - So even if the ranking disappears, it is saved
      this.data.details.rankingJournal = this.data.auxRanking.selected ? this.data.auxRanking.selected.designacao : null;

      this.data.details.scopus = this.data.auxScopus.selected ? this.data.auxScopus.selected.value : 0;
      this.data.details.cited = this.data.auxCited.selected ? this.data.auxCited.selected.value : 0;
      this.data.details.differentInstitutionsAuthors = this.data.auxDifferent.selected ? this.data.auxDifferent.selected.value : 0;
      this.data.details.openAccess = this.data.auxOpenAccess.selected ? this.data.auxOpenAccess.selected.value : 0;
      this.data.details.specialIssue = this.data.auxSpecialIssue.selected ? this.data.auxSpecialIssue.selected.value : 0;
      this.data.details.internationalConference = this.data.auxInternationalConference.selected ? this.data.auxInternationalConference.selected.value : 0;
      this.data.details.citizenScienceApproach = this.data.auxCitizen.selected ? this.data.auxCitizen.selected.value : 0;
      this.data.details.performedPublicConsultation = this.data.auxPerformed.selected ? this.data.auxPerformed.selected.value : 0;
      this.data.details.socialJustice = this.data.auxSocialJustice.selected ? this.data.auxSocialJustice.selected.value : 0;
      this.data.details.internationalCollaboration = this.data.auxInternational.selected ? this.data.auxInternational.selected.value : 0;
      this.data.details.developingCountries = this.data.auxDevelopingCountries.selected ? this.data.auxDevelopingCountries.selected.value : 0;
      this.data.details.industry = this.data.auxIndustry.selected ? this.data.auxIndustry.selected.value : 0;

      this.data.details.criadoPorId = this.user.id;
      this.data.details.dataCriacao = moment().format();
      this.data.details.atualizadoPorId = this.user.id;
      this.data.details.atualizadoa = moment().format();

      this.Publicacao.create(this.data.details).$promise.then((publicacao) => {
        // Create all Autores
        let deferAutores = this.$q.defer();
        this.PublicacaoService.createMultipleData(this.PublicacaoAutor, this.data.autores, publicacao.id, 'publicacaoId').then((x) => {
          deferAutores.resolve({ok: true});
        }).catch(err => {
          deferAutores.resolve({ok: false, output: 'Autores de Publicação'});
        });

        // Create all Áreas
        let deferAreas = this.$q.defer();
        this.PublicacaoService.createMultipleData(this.PublicacaoAreaInterdisciplinar, this.data.areas, publicacao.id, 'publicacaoId').then((x) => {
          deferAreas.resolve({ok: true});
        }).catch(err => {
          deferAreas.resolve({ok: false, output: 'Áreas Interdisciplinares'});
        });

        // Create all Grupos Investigação
        let deferGruposInvestigacao = this.$q.defer();
        this.PublicacaoService.createMultipleData(this.PublicacaoGrupoInvestigacao, this.data.grupos, publicacao.id, 'publicacaoId').then((x) => {
          deferGruposInvestigacao.resolve({ok: true});
        }).catch(err => {
          deferGruposInvestigacao.resolve({ok: false, output: 'Grupos de Investigação'});
        });

        // Save Impacto
        let deferImpacto = this.$q.defer();
        this.saveImpacto(this.data.impacto, publicacao, this.Publicacao).then(x => {
          deferImpacto.resolve({ok: true});
        }).catch(err => {
          deferImpacto.resolve(err); // Resolve data is solved inside since it's multi-answer
        });

        let promises = [deferAutores.promise, deferAreas.promise, deferGruposInvestigacao.promise, deferImpacto.promise];

        // After all multiple data information is created/settled
        this.$q.all(promises).then((res) => {
          this.UI.addToast("Publicação criada com sucesso");

          localStorage.removeItem('ISR_SGI_PublicacaoNewForm');
          this.publicacaoCreated = true;

          let error = this.createdMultipleDataOk(res);
          if (error) {
            let errorMessage = "Publicação criada, mas ocorreram erros a inserir os seguintes dados: " + error + ". Por favor verifique e adicione-os manualmente";
            alert = this.UI.showAlert(errorMessage);
            alert.finally(() => {
              // Check for validity and redirect to details view so it can be filled
              this.Publicacao.checkValido({publicacaoId: publicacao.id}).$promise.then(data => {
                this.state.go('app.publicacao.details', {id: publicacao.id});
              }).catch(err => {
                console.log(err);
                this.UI.addToast("Não foi possível verificar validade da publicação.");
              });
            });
          } else { // Check for validity and redirect
            this.Publicacao.checkValido({publicacaoId: publicacao.id}).$promise.then(data => {
              this.state.go('app.publicacao.list');
            }).catch(err => {
              console.log(err);
              this.UI.addToast("Não foi possível verificar validade da publicação.");
            });
          }
        }).catch(err => { // Should never happen, since resolving everything...
          console.log(err);
          localStorage.removeItem('ISR_SGI_PublicacaoNewForm');
          this.publicacaoCreated = true;
          alert = this.UI.showAlert("Publicação criada, mas ocorreram erros a inserir alguns dados. Por favor verifique e adicione-os manualmente");
          alert.finally(() => {
            // Redirect to details view so it can be filled
            this.state.go('app.publicacao.details', {id: publicacao.id});
          });
        });
      }).catch((error) => {
        console.log(error);
        this.UI.showAlert("Erro ao criar publicação. Verifique a ligação");
        this.loaded = true;
      });
    }).catch((x) => {
      // Nothing to do. Just fix values and resubmit...
    });
  };


  // Function called when changing Sim/Não
  // Clear <variable>Text if it becomes Não (assumes all variables have a Text field too)
  toggleOptionalData = (auxData, label) => {
    let labelText = label + 'Text';
    this.data.details[label] = auxData.selected.value;
    if (auxData.selected.value === 0) { // It was disabled, clear text
      this.data.details[labelText] = null;
    } else { // Do nothing
    }
  };

  // Check if there was an error adding multiple data, and return a string with the bad inserted data
  createdMultipleDataOk = (res) => {
    let output = '';
    if (res && res.length > 0) {
      res.forEach(r => {
        if (!r.ok) output += r.output + ", ";
      });
      // If there's data, remove trailing ", "
      if (output.length > 0)
        return output.slice(0, -2);
    }
    return output.length === 0 ? null : output;
  };


  isValid = () => {
    let validDefer = this.$q.defer();
    let v = true;

    // Check if publicacao data is well defined
    // Título
    if (v && (!this.data.details.titulo || this.data.details.titulo.length === 0)) {
      this.UI.addToast("Título não preenchido");
      v = false;
      validDefer.reject();
    }

    // Slug
    if (v && (!this.PublicacaoService.isValidSlug(this.data.details.slug))) {
      this.UI.addToast("Slug inválido, use apenas letras minúsculas, números e hífenes, sem espaços nem acentos.");
      v = false;
      validDefer.reject();
    }

    // Ano de Publicacao
    if (v && (this.data.details.ano && isNaN(this.data.details.ano))) {
      this.UI.addToast("Ano de Publicação inválido");
      v = false;
      validDefer.reject();
    }

    // Tipo de Publicacao
    if (v && (!this.data.auxTipo || !this.data.auxTipo.selected)) {
      this.UI.addToast("Tipo de Publicação inválido");
      v = false;
      validDefer.reject();
    }

    // SCOPUS
    // if (v && (!this.data.auxScopus || !this.data.auxScopus.selected)) {
    //   this.UI.addToast("Informação de SCOPUS inválida");
    //   v = false;
    //   validDefer.reject();
    // }

    // Highly Cited Paper
    // if (v && (!this.data.auxCited || !this.data.auxCited.selected)) {
    //   this.UI.addToast("Highly Cited Paper - valor inválido");
    //   v = false;
    //   validDefer.reject();
    // }

    // Different institutions authors
    // if (v && (!this.data.auxDifferent || !this.data.auxDifferent.selected)) {
    //   this.UI.addToast("Diferent institutions authors - valor inválido");
    //   v = false;
    //   validDefer.reject();
    // }

    // Open Access
    // if (v && (!this.data.auxOpenAccess || !this.data.auxOpenAccess.selected)) {
    //   this.UI.addToast("Open Access - valor inválido");
    //   v = false;
    //   validDefer.reject();
    // }

    // Special Issue
    // if (v && (!this.data.auxSpecialIssue || !this.data.auxSpecialIssue.selected)) {
    //   this.UI.addToast("Special Issue - valor inválido");
    //   v = false;
    //   validDefer.reject();
    // }

    // In Proceedings of International Conference
    // if (v && (!this.data.auxInternationalConference || !this.data.auxInternationalConference.selected)) {
    //   this.UI.addToast("In Proceedings of International Conference - valor inválido");
    //   v = false;
    //   validDefer.reject();
    // }

    // Citizen science approach
    // if (v && (!this.data.auxCitizen || !this.data.auxCitizen.selected)) {
    //   this.UI.addToast("Citizen science approach - valor inválido");
    //   v = false;
    //   validDefer.reject();
    // }

    // Performed public consultation
    // if (v && (!this.data.auxPerformed || !this.data.auxPerformed.selected)) {
    //   this.UI.addToast("Performed public consultation - valor inválido");
    //   v = false;
    //   validDefer.reject();
    // }

    // Social justice
    // if (v && (!this.data.auxSocialJustice || !this.data.auxSocialJustice.selected)) {
    //   this.UI.addToast("Addresses social justice - valor inválido");
    //   v = false;
    //   validDefer.reject();
    // }

    // International collaboration
    // if (v && (!this.data.auxInternational || !this.data.auxInternational.selected)) {
    //   this.UI.addToast("International collaboration - valor inválido");
    //   v = false;
    //   validDefer.reject();
    // }

    // Involves researchers from developing countries?
    // if (v && (!this.data.auxDevelopingCountries || !this.data.auxDevelopingCountries.selected)) {
    //   this.UI.addToast("Developing Countries - valor inválido");
    //   v = false;
    //   validDefer.reject();
    // }

    // Involves researchers from developing countries?
    // if (v && (!this.data.auxIndustry || !this.data.auxIndustry.selected)) {
    //   this.UI.addToast("Authors/co-authors from the industry or non-academic staff - valor inválido");
    //   v = false;
    //   validDefer.reject();
    // }

    // Mandatory multiple data
    if (v && (this.data.autores.length === 0)) {
      this.UI.addToast("Publicação sem Autor(es) definido(s)");
      v = false;
      validDefer.reject();
    }

    // if (v && (this.data.areas.length === 0)) {
    //   this.UI.addToast("Áreas Interdisciplinares não preenchidas");
    //   v = false;
    //   validDefer.reject();
    // }

    if (v && (this.data.areas.length > 3)) {
      this.UI.addToast("Só podem ser adicionadas 3 áreas interdisciplinares");
      v = false;
      validDefer.reject();
    }

    // Check if data is unique for multiple data
    // Autores
    let autores = this.data.autores.map(x => x.investigadorId);
    // Special case - if no investigadorId exists, we can't control repeats, so don't use it for repeats
    autores = autores.filter(x => x);
    let autoresRepetidos = autores.filter((x, i) => autores.indexOf(x) !== i);
    if (v && autoresRepetidos.length > 0) {
      this.UI.addToast("Autor investigador repetido");
      v = false;
      validDefer.reject();
    }
    // Áreas Interdisciplinares
    let areas = this.data.areas.map(x => x.areaId);
    let areasRepetidas = areas.filter((x, i) => areas.indexOf(x) !== i);
    if (v && areasRepetidas.length > 0) {
      this.UI.addToast("Áreas Interdisciplinares repetidas");
      v = false;
      validDefer.reject();
    }
    // Grupos Investigação
    let gruposInvestigacao = this.data.grupos.map(x => x.grupoInvestigacaoId);
    let gruposRepetidos = gruposInvestigacao.filter((x, i) => gruposInvestigacao.indexOf(x) !== i);
    if (v && gruposRepetidos.length > 0) {
      this.UI.addToast("Grupos de Investigação repetidos");
      v = false;
      validDefer.reject();
    }

    // Only validate multidata if all static data is valid, otherwise no point first
    if (v) {
      // VALIDATE ASYNC DATA
      let idData = [];

      // If slug is filled, we need to check if it exists already too
      idData.push({
        field: 'slug',
        value: this.data.details.slug,
        model: this.Publicacao,
        resolveOnExist: false,
        error: "Já existe este slug associado a outra publicação"
      });

      // Add multi async data to verify
      this.data.autores.forEach(x => {
        // Only add actual investigadores
        if (x.investigadorId) {
          idData.push({
            field: 'id',
            value: x.investigadorId,
            model: this.Investigador,
            resolveOnExist: true, // It's resolved if it finds one
            error: "Investigador inexistente"
          });
        }
      });
      this.data.areas.forEach(x => {
        idData.push({
          field: 'id',
          value: x.areaId,
          model: this.AreaInterdisciplinar,
          resolveOnExist: true, // It's resolved if it finds one
          error: "Área Interdisciplinar inexistente"
        });
      });
      this.data.grupos.forEach(x => {
        idData.push({
          field: 'id',
          value: x.grupoInvestigacaoId,
          model: this.GrupoInvestigacao,
          resolveOnExist: true, // It's resolved if it finds one
          error: "Grupo de Investigação inexistente"
        });
      });

      let wait = this.UI.showWaiting();
      // Verify all the async data
      this.PublicacaoService.validateMultiData(idData).then(x => {

        // Verify impactos
        this.verifyImpactos(this.data.impacto).then(y => {
          wait.close();
          validDefer.resolve();
        }).catch(() => {
          wait.close();
          validDefer.reject();
        });

      }).catch(() => {
        wait.close();
        validDefer.reject();
      });
    }
    return validDefer.promise;
  };


  // MULTIPLE DATA CRUDs
  // Adicionar um novo investigador para publicacao
  addElemento = () => {
    let wait = this.UI.showWaiting();
    this.Investigador.find({}).$promise.then((investigadores) => {
      investigadores.sort((a, b) => a.nome.localeCompare(b.nome));
      wait.close();
      let options = {
        size: 'lg',
        template: require('./edit.autor.dialog.html'),
        controller: ['$scope', '$dialog', ($scope, $dialog) => {
          $scope.elemento = {};
          $scope.label = "Adicionar Autor da Publicação";
          $scope.investigadores = investigadores;
          $scope.isInvestigador = false;

          $scope.auxInvestigador = {
            selected: undefined,
            infiniteScroll: {numToAdd: 20, currentItems: 20}
          };

          // Automatically update autorDisplay when investigador is selected
          $scope.onInvestigadorSelected = (item) => {
            $scope.elemento.autorDisplay = item.nome;
          };

          // Called just before switch is toggled, so logic is reversed
          $scope.onSwitch = () => {
            if ($scope.isInvestigador) { // We clicked to do Other Autor, clear selection
              $scope.auxInvestigador.selected = undefined;
            } else { // We clicked to do Investigador, clear other data
              $scope.elemento = {};
            }
          };

          // Infinite Scroll magic
          $scope.addMoreItems = (infiniteScroll) => {
            infiniteScroll.currentItems += infiniteScroll.numToAdd;
          };

          $scope.ok = () => {
            $dialog.close($scope);
          };

          $scope.cancel = () => {
            $dialog.dismiss('cancel');
          };
        }]
      };
      let dialogEdit = this.UI.showDialog(options);
      dialogEdit.then(ok => {
        if (ok.auxInvestigador && ok.elemento) {
          let item = angular.copy(ok.elemento);

          if (ok.isInvestigador && ok.auxInvestigador.selected) {
            item.investigadorId = ok.auxInvestigador.selected.id;
            item.investigador = angular.copy(ok.auxInvestigador.selected);
          } else if (!ok.isInvestigador && ok.elemento.autor) {
            item.investigadorId = null;
            item.autor = ok.elemento.autor;
            item.autorDisplay = ok.elemento.autor; // If we didn't fill it manually, use the autor name
          }
          // Add ordem
          item.ordem = this.data.autores.length + 1;

          this.data.autores.push(item);
        }
      });
    }).catch((error) => {
      wait.close();
      console.log(error);
      this.UI.addToast("Não foi possível ler investigadores para publicação. Verifique a sua ligação");
    });
  };

  // Edita informação de autor para publicacao
  editElemento = (x) => {
    let wait = this.UI.showWaiting();
    this.Investigador.find({}).$promise.then((investigadores) => {
      investigadores.sort((a, b) => a.nome.localeCompare(b.nome));
      wait.close();
      let options = {
        size: 'lg',
        template: require('./edit.autor.dialog.html'),
        controller: ['$scope', '$dialog', ($scope, $dialog) => {
          $scope.elemento = angular.copy(x);
          $scope.label = "Editar Autor da Publicação";
          $scope.investigadores = investigadores;
          $scope.isInvestigador = $scope.elemento.investigador !== undefined;

          $scope.auxInvestigador = {
            selected: $scope.elemento.investigador,
            infiniteScroll: {numToAdd: 20, currentItems: 20}
          };

          // Automatically update autorDisplay when investigador is selected
          $scope.onInvestigadorSelected = (item) => {
            $scope.elemento.autorDisplay = item.nome;
          };

          // Called just before switch is toggled, so logic is reversed
          $scope.onSwitch = () => {
            if ($scope.isInvestigador) { // We clicked to do Other Autor, clear selection
              $scope.auxInvestigador.selected = undefined;
            } else { // We clicked to do Investigador, clear other data
              $scope.elemento = {};
            }
          };

          // Infinite Scroll magic
          $scope.addMoreItems = (infiniteScroll) => {
            infiniteScroll.currentItems += infiniteScroll.numToAdd;
          };

          $scope.ok = () => {
            $dialog.close($scope);
          };

          $scope.cancel = () => {
            $dialog.dismiss('cancel');
          };
        }]
      };
      let dialogEdit = this.UI.showDialog(options);
      dialogEdit.then(ok => {
        if (ok.auxInvestigador && ok.elemento) {
          if (ok.isInvestigador && ok.auxInvestigador.selected) {
            x.investigadorId = ok.auxInvestigador.selected.id;
            x.investigador = angular.copy(ok.auxInvestigador.selected);
            x.autor = undefined;
            x.autorDisplay = ok.elemento.autorDisplay;
          } else if (!ok.isInvestigador && ok.elemento.autor) {
            delete x.investigador;
            x.investigadorId = null;
            x.autor = ok.elemento.autor;
            x.autorDisplay = ok.elemento.autor; // Copy from autor if not investigador
          }
        }
      });
    }).catch((error) => {
      wait.close();
      console.log(error);
      this.UI.addToast("Não foi possível ler investigadores para publicação. Verifique a sua ligação");
    });
  };

  // Remove Elemento com índice index
  removeElemento = (index) => {
    if (index < this.data.autores.length) {
      this.data.autores.splice(index, 1);
    }
  };


  // Adicionar uma nova área interdisciplinar para publicação
  addArea = () => {
    // Only allow a max of 3 areas
    if (this.data.areas.length >= 3) {
      this.UI.addToast("Só é possível escolher até 3 áreas");
      return;
    }
    let wait = this.UI.showWaiting();
    this.AreaInterdisciplinar.find({}).$promise.then((areas) => {
      wait.close();
      let options = {
        size: 'lg',
        template: require('./edit.area.dialog.html'),
        controller: ['$scope', '$dialog', ($scope, $dialog) => {
          $scope.area = {};
          $scope.label = "Adicionar Área Interdisciplinar";
          $scope.areas = areas;

          $scope.auxArea = {
            selected: undefined,
            infiniteScroll: {numToAdd: 20, currentItems: 20}
          };

          // Infinite Scroll magic
          $scope.addMoreItems = (infiniteScroll) => {
            infiniteScroll.currentItems += infiniteScroll.numToAdd;
          };

          $scope.ok = () => {
            $dialog.close($scope);
          };

          $scope.cancel = () => {
            $dialog.dismiss('cancel');
          };
        }]
      };
      let dialogEdit = this.UI.showDialog(options);
      dialogEdit.then(ok => {
        if (ok.auxArea && ok.area) {
          let item = angular.copy(ok.area);

          item.areaId = ok.auxArea.selected.id;
          item.area = ok.auxArea.selected;

          this.data.areas.push(item);
        }
      });
    }).catch((error) => {
      wait.close();
      console.log(error);
      this.UI.addToast("Não foi possível ler áreas para publicação. Verifique a sua ligação");
    });

  };

  // Edita informação de área interdisciplinar para publicação
  editArea = (x) => {
    let wait = this.UI.showWaiting();
    this.AreaInterdisciplinar.find({}).$promise.then((areas) => {
      wait.close();
      let options = {
        size: 'lg',
        template: require('./edit.area.dialog.html'),
        controller: ['$scope', '$dialog', ($scope, $dialog) => {
          $scope.area = angular.copy(x);
          $scope.label = "Editar Área Interdisciplinar";
          $scope.areas = areas;

          $scope.auxArea = {
            selected: $scope.area.area,
            infiniteScroll: {numToAdd: 20, currentItems: 20}
          };

          // Infinite Scroll magic
          $scope.addMoreItems = (infiniteScroll) => {
            infiniteScroll.currentItems += infiniteScroll.numToAdd;
          };

          $scope.ok = () => {
            $dialog.close($scope);
          };

          $scope.cancel = () => {
            $dialog.dismiss('cancel');
          };
        }]
      };
      let dialogEdit = this.UI.showDialog(options);
      dialogEdit.then(ok => {
        if (ok.auxArea && ok.area) {
          x.areaId = ok.auxArea.selected.id;
          x.area = angular.copy(ok.auxArea.selected);
        }
      });
    }).catch((error) => {
      wait.close();
      console.log(error);
      this.UI.addToast("Não foi possível ler áreas para publicação. Verifique a sua ligação");
    });
  };

  // Remove área interdisciplinar com índice index
  removeArea = (index) => {
    if (index < this.data.areas.length) {
      this.data.areas.splice(index, 1);
    }
  };

  // Grupos Investigação
  // Adicionar um novo grupo de investigação para publicação
  addGrupoInvestigacao = () => {
    let wait = this.UI.showWaiting();
    this.GrupoInvestigacao.find({}).$promise.then((gruposInvestigacao) => {
      wait.close();
      let options = {
        size: 'lg',
        template: require('./edit.grupo.investigacao.dialog.html'),
        controller: ['$scope', '$dialog', ($scope, $dialog) => {
          $scope.grupo = {};
          $scope.label = "Adicionar Grupo de Investigação";
          $scope.grupos = gruposInvestigacao;

          $scope.auxGrupoInvestigacao = {
            selected: undefined,
            infiniteScroll: {numToAdd: 20, currentItems: 20}
          };

          // Infinite Scroll magic
          $scope.addMoreItems = (infiniteScroll) => {
            infiniteScroll.currentItems += infiniteScroll.numToAdd;
          };

          $scope.ok = () => {
            $dialog.close($scope);
          };

          $scope.cancel = () => {
            $dialog.dismiss('cancel');
          };
        }]
      };
      let dialogEdit = this.UI.showDialog(options);
      dialogEdit.then(ok => {
        if (ok.auxGrupoInvestigacao && ok.grupo) {
          let item = angular.copy(ok.grupo);
          item.grupoInvestigacaoId = ok.auxGrupoInvestigacao.selected.id;
          item.grupo = angular.copy(ok.auxGrupoInvestigacao.selected);

          this.data.grupos.push(item);
        }
      });
    }).catch(error => {
      wait.close();
      console.log(error);
      this.UI.addToast("Não foi possível ler grupos de investigação. Verifique a sua ligação");
    });
  };

  // Edita informação de instituicao para produto
  editGrupoInvestigacao = (x) => {
    let wait = this.UI.showWaiting();
    this.GrupoInvestigacao.find({}).$promise.then((grupos) => {
      wait.close();
      let options = {
        size: 'lg',
        template: require('./edit.grupo.investigacao.dialog.html'),
        controller: ['$scope', '$dialog', ($scope, $dialog) => {
          $scope.grupo = angular.copy(x);
          $scope.label = "Editar Grupo de Investigação";
          $scope.grupos = grupos;

          $scope.auxGrupoInvestigacao = {
            selected: $scope.grupo.grupo,
            infiniteScroll: {numToAdd: 20, currentItems: 20}
          };

          // Infinite Scroll magic
          $scope.addMoreItems = (infiniteScroll) => {
            infiniteScroll.currentItems += infiniteScroll.numToAdd;
          };

          $scope.ok = () => {
            $dialog.close($scope);
          };

          $scope.cancel = () => {
            $dialog.dismiss('cancel');
          };
        }]
      };
      let dialogEdit = this.UI.showDialog(options);
      dialogEdit.then(ok => {
        if (ok.auxGrupoInvestigacao && ok.grupo) {
          // Update data without replacing the variable x (so it's still an element of the array)

          x.grupoInvestigacaoId = ok.auxGrupoInvestigacao.selected.id;
          x.grupo = angular.copy(ok.auxGrupoInvestigacao.selected);
        }
      });
    }).catch((error) => {
      wait.close();
      console.log(error);
      this.UI.addToast("Não foi possível ler grupos de investigação. Verifique a sua ligação");
    });
  };

  // Remove Instituição com índice index
  removeGrupoInvestigacao = (index) => {
    if (index < this.data.grupos.length) {
      this.data.grupos.splice(index, 1);
    }
  };

  // Impactos
  // Get data to be used in impacto edit modal
  getImpactoData = (tipo) => {
    let wait;
    let defer = this.$q.defer();
    switch(tipo) {
      case 'Ambiental':
        defer.resolve(null);
        break;
      case 'Económico':
        defer.resolve(null);
        break;
      case 'ODS':
        wait = this.UI.showWaiting();
        this.Ods.find({}).$promise.then((ods) => {
          wait.close();
          defer.resolve(ods);
        }).catch((error) => {
          wait.close();
          console.log(error);
          defer.reject(error);
        });
        break;
      case 'Social':
        defer.resolve(null);
        break;
    }
    return defer.promise;
  };

  // Edit/add impacto for tipo
  editImpacto = (tipo) => {
    this.getImpactoData(tipo).then(externalData => {
      let options = {
        size: 'lg',
        template: require('./impacto.dialog.html'),
        controller: ['$scope', '$dialog', ($scope, $dialog) => {
          $scope.tipo = tipo;
          $scope.label = "Editar Impacto " + tipo;
          $scope.impacto = angular.copy(this.data.impacto);
          switch(tipo) {
            case 'Ambiental':
              $scope.simnao = this.simnao;
              $scope.auxImpactoAmbiental = angular.copy(this.data.auxImpactoAmbiental);
              break; // Nothing to do
            case 'Económico':
              $scope.simnao = this.simnao;
              $scope.auxImpactoEconomico = angular.copy(this.data.auxImpactoEconomico);
              break;
            case 'ODS':
              $scope.externalData = externalData;
              // ODS is always "add", so it always starts as empty
              $scope.auxOds = {
                selected: undefined,
                infiniteScroll: {numToAdd: 20, currentItems: 20}
              };
              break;
            case 'Social':
              $scope.simnao = this.simnao;
              $scope.auxImpactoSocial = angular.copy(this.data.auxImpactoSocial);
              break;
          }

          // Infinite Scroll magic
          $scope.addMoreItems = (infiniteScroll) => {
            infiniteScroll.currentItems += infiniteScroll.numToAdd;
          };

          $scope.ok = () => {
            $dialog.close($scope);
          };

          $scope.cancel = () => {
            $dialog.dismiss('cancel');
          };
        }]
      };
      let dialogEdit = this.UI.showDialog(options);
      dialogEdit.then(ok => {
        switch(tipo) {
          case 'Ambiental':
            if(ok.auxImpactoAmbiental && ok.auxImpactoAmbiental.selected.value) { // Has "Yes" selected
              this.data.auxImpactoAmbiental = angular.copy(ok.auxImpactoAmbiental);
              this.data.impacto.ambiental = ok.impacto.ambiental;
              this.UI.addToast("Impacto ambiental atualizado");
            } else { // No ambiental data is defined, delete it
              if (this.data.impacto.ambiental) { // If it's filled, delete it, otherwise don't bother
                this.data.auxImpactoAmbiental.selected = undefined;
                delete this.data.impacto.ambiental;
                this.UI.addToast("Impacto ambiental eliminado");
              }
            }
            break;
          case 'Económico':
            if(ok.auxImpactoEconomico && ok.auxImpactoEconomico.selected.value) { // Has "Yes" selected
              this.data.auxImpactoEconomico = angular.copy(ok.auxImpactoEconomico);
              this.data.impacto.economico = ok.impacto.economico;
              this.UI.addToast("Impacto económico atualizado");
            } else { // No economico data is defined, delete it
              if (this.data.impacto.economico) { // If it's filled, delete it, otherwise don't bother
                this.data.auxImpactoEconomico.selected = undefined;
                delete this.data.impacto.economico;
                this.UI.addToast("Impacto económico eliminado");
              }
            }
            break;
          case 'ODS':
            // Check repeats - Placed here instead of isValid() so it's easier to port
            let usedOds = this.data.impacto.ods.map(x => x.odsId);
            usedOds.push(ok.auxOds.selected.id);
            let odsRepetidos = usedOds.filter((x, i) => usedOds.indexOf(x) !== i);
            if (odsRepetidos.length > 0) {
              this.UI.addToast("ODS já adicionada");
            } else { // We can add it
              this.data.impacto.ods.push({
                odsId: ok.auxOds.selected.id,
                ods: { id: ok.auxOds.selected.id, designacao: ok.auxOds.selected.designacao }
              });
              this.UI.addToast("ODS adicionado com sucesso");
            }
            break;
          case 'Social':
            if(ok.auxImpactoSocial && ok.auxImpactoSocial.selected.value) { // Has "Yes" selected
              this.data.auxImpactoSocial = angular.copy(ok.auxImpactoSocial);
              this.data.impacto.social = ok.impacto.social;
              this.UI.addToast("Impacto social atualizado");
            } else { // No social data is defined, delete it
              if (this.data.impacto.social) { // If it's filled, delete it, otherwise don't bother
                this.data.auxImpactoSocial.selected = undefined;
                delete this.data.impacto.social;
                this.UI.addToast("Impacto social eliminado");
              }
            }
            break;
        }
      });
    }).catch(error => {
      console.log(error);
      this.UI.addToast("Não foi possível ler dados para edição. Verifique a sua ligação");
    });
  };

  // Function called when changing Sim/Não
  // Clear text if it becomes Não
  togglePolicyInfluence = () => {
    if (this.data.auxImpactoPolicyInfluence) {
      if (this.data.auxImpactoPolicyInfluence.selected.value === 0) { // It was disabled, clear text
        this.data.impacto.policyInfluence = null;
      } else { // Do nothing
      }
    }
  };

  // Returns true or false if impactos data is ok to set to database
  verifyImpactos = (impacto) => {
    let defer = this.$q.defer();
    // Ambiental - Nothing to check
    // Social - Nothing to check
    // Económico - Nothing to check

    // ODS - Verifica ODSs individuais
    let deferOds = this.$q.defer();
    if (impacto.ods && impacto.ods.length > 0) {
      let odsTasks = [];
      for (let i = 0; i < impacto.ods.length; i++) {
        let o = this.$q.defer();

        this.PublicacaoService.fieldValueExists('id', impacto.ods[i].id, this.Ods).then((exists) => {
          o.resolve(exists);
        }).catch(error => {
          o.reject(error);
        });
        odsTasks.push(o.promise);
      }

      this.$q.all(odsTasks).then(x => {
        deferOds.resolve(true);
      }).catch(error => {
        deferOds.reject(error);
      });
    } else {
      deferOds.resolve(true);
    }

    this.$q.all([deferOds.promise]).then(x => {
      defer.resolve();
    }).catch(error => {
      this.UI.addToast("Não foi possível verificar dados de impactos. Verifique a ligação");
      defer.reject(error);
    });

    return defer.promise;
  };

  // Save impacto data to database, update object with impactoId of type Model
  saveImpacto = (imp, object, Model) => {
    let defer = this.$q.defer();
    let newImpacto = {
      id: 0,
      ambiental: imp.ambiental || null,
      economico: imp.economico || null,
      social: imp.social || null,
      observacoes: imp.observacoes || null,
      policyInfluence: imp.policyInfluence || null,
      criadoPorId: this.user.id,
      dataCriacao: moment().format()
    };

    this.Impacto.create(newImpacto).$promise.then((impacto) => {
      // Save impactoId to base object for reference
      object.impactoId = impacto.id;
      Model.upsert(object).$promise.then((res) => {
        defer.resolve();
        // Create all ODS
        this.PublicacaoService.createMultipleData(this.ImpactoOds, imp.ods, impacto.id, 'impactoId').then(x => {
          defer.resolve();
        }).catch(error => {
          console.log(error);
          defer.reject({ok: false, output: 'Impacto - ODS'});
        });
      }).catch((error) => {
        console.log(error);
        defer.reject({ok: false, output: 'Ligação a Impacto'});
      });
    }).catch((error) => {
      console.log(error);
      defer.reject({ok: false, output: 'Impacto'});
    });

    return defer.promise;
  };

  removeImpacto = (tipo, index) => {
    switch(tipo) {
      case 'Ambiental':
        this.data.auxImpactoAmbiental.selected = undefined;
        delete this.data.impacto.ambiental;
        this.UI.addToast("Impacto ambiental eliminado");
        break;
      case 'Económico':
        this.data.auxImpactoEconomico.selected = undefined;
        delete this.data.impacto.economico;
        this.UI.addToast("Impacto económico eliminado");
        break;
      case 'ODS':
        if (index < this.data.impacto.ods.length) {
          this.data.impacto.ods.splice(index, 1);
          this.UI.addToast("Objetivo eliminado");
        }
        break;
      case 'Social':
        this.data.auxImpactoSocial.selected = undefined;
        delete this.data.impacto.social;
        this.UI.addToast("Impacto social eliminado");
        break;
    }
  };

  updateSlug = () => {
    this.data.details.slug = this.PublicacaoService.stringToSlug(this.data.details.titulo);
  };

}

PublicacaoCreatePublicacaoController.$inject = ['$q', '$state', '$scope', 'AuthenticationService', 'UIService', 'PublicacaoService', 'Publicacao', 'PublicacaoAutor', 'PublicacaoTipo', 'PublicacaoAreaInterdisciplinar', 'PublicacaoGrupoInvestigacao', 'Ranking', 'Investigador', 'AreaInterdisciplinar', 'GrupoInvestigacao', 'Impacto', 'ImpactoOds', 'Ods', 'Pais', 'InvestigadorTooltip', 'Revista'];
